import { VOWEL_REGEX } from '@monoimin/constants';

export function startsWithVowel(word: string) {
  return VOWEL_REGEX.test(word);
}

export default startsWithVowel;
